import React from 'react'
import './PageHeader.css'

export default function PageHeader({
  title,
  description,
  icon,
  accentColor = 'blue',
  actions
}) {
  const colorMap = {
    purple: 'header-purple',
    green: 'header-green',
    blue: 'header-blue',
    orange: 'header-orange',
    red: 'header-red',
    teal: 'header-teal'
  }

  const themeClass = colorMap[accentColor] || 'header-blue'
  const iconNode = typeof icon === 'string' ? <i className={icon}></i> : icon

  return (
    <div className={`unified-page-header ${themeClass}`}>
      <div className="header-icon-wrapper">
        {iconNode}
      </div>
      <div className="header-content">
        <div className="header-text">
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
        {actions && <div className="header-actions">{actions}</div>}
      </div>
    </div>
  )
}
